module.exports = __webpack_public_path__ + "static/media/project5.0e44309c.png";